import {
  GET_LIST_THUCHINGOAILE,
  GET_LIST_THUCHINGOAILE_SUCCESS,
  GET_LIST_THUCHINGOAILE_FAILURE,
} from "./actionTypes";

export const getListThuChiNgoaiLe = (dataSearch) => ({
  type: GET_LIST_THUCHINGOAILE,
  dataSearch,
});

export const getListThuChiNgoaiLeSuccess = (data) => ({
  type: GET_LIST_THUCHINGOAILE_SUCCESS,
  payload: data,
});

export const getListThuChiNgoaiLeFailure = () => ({
  type: GET_LIST_THUCHINGOAILE_FAILURE,
});
